<div class="graph-page-container">
    <div class="main-container">
        <div *ngIf="selectedGraph" class="graph-container">
            <ng-container>
                <div class="graph-header-container">
                    <div class="graph-title-wrapper">
                        {{ getGraphTypeName(selectedGraph.type) }}
                        <span class="graph-main-title">
                            {{ selectedGraph.title | translate }}
                            <mat-icon class="small-icon" svgIcon="edit-pen" (click)="renameGraph()" />
                        </span>
                    </div>
                    <div class="button-wrap">
                        <button (click)="cancel()" class="white" data-cy="graphs-cancel-button">
                            {{ 'graph.exhaust.table.button.cancel' | translate }}
                        </button>
                        <button class="save" data-cy="graphs-save-button" (click)="save()" [disabled]="!saveIsEnabled && !isTitleChanged">
                            {{ 'graph.exhaust.table.button.save' | translate }}
                        </button>
                    </div>
                </div>
                <app-exhaust-graph-table
                    *ngIf="isExhaustGraph"
                    class="page-container"
                    [graph]="selectedGraph"
                    [closeEvent]="closeGraph$.asObservable()"
                    [saveEvent]="saveGraph$.asObservable()"
                    (onCloseGraph)="setGraph(null)"
                    (onUpdateSave)="updateSaveButton($event)">
                </app-exhaust-graph-table>

                <ng-container *ngIf="isGaugeGraph">
                    <app-gauge-graph-table
                        class="page-container"
                        [graph]="selectedGraph"
                        [closeEvent]="closeGraph$.asObservable()"
                        [saveEvent]="saveGraph$.asObservable()"
                        (onCloseGraph)="setGraph(null)"
                        (onUpdateSave)="updateSaveButton($event)">
                    </app-gauge-graph-table>
                </ng-container>

                <ng-container *ngIf="isBarGraph">
                    <app-bar-graph-table
                        class="page-container"
                        [graph]="selectedGraph"
                        [closeEvent]="closeGraph$.asObservable()"
                        [saveEvent]="saveGraph$.asObservable()"
                        (onCloseGraph)="setGraph(null)"
                        (onUpdateSave)="updateSaveButton($event)">
                    </app-bar-graph-table>
                </ng-container>
            </ng-container>
            <div class="bottom"></div>
        </div>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'graph.cancel.dialog.title'"
    [discardLabel]="'graph.cancel.dialog.discard'"
    [goBackLabel]="'graph.cancel.dialog.go-back'"
    [saveLabel]="'graph.cancel.dialog.save'">
</app-confirmation-window>


<app-confirmation-window
    #saveWithoutExtra
    [mainLabel]="'graphs.exit-graph.without.extra.title'"
    [subLabel]="'graphs.exit-graph.without.extra.text'"
    [saveLabel]="'graphs.exit-graph.without.extra.button.exit'"
    [discardLabel]="'graphs.exit-graph.without.extra.button.go-back'"
    [allButtonsLeft]="true"
>
</app-confirmation-window>



